import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { DsrRequest, FOIRequest, IBSRequest, VisitRequest, KnowledgeCenter, Survey } from './pages';

export const AppRoute: React.FC = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={DsrRequest} />
      <Route path="/visit-request/:requestId" component={VisitRequest} />
      <Route path="/ibs-request/:languageId?" component={IBSRequest} />
      <Route path="/knowledge-center/:languageId?" component={KnowledgeCenter} />
      <Route path="/foi-request/:languageId?" component={FOIRequest} />
      <Route path="/survey/:id" component={Survey} />
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  </BrowserRouter>
);
